import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectReadingPanePositionOption')(function selectReadingPanePositionOption(selection, state) {
    var optionState = state.optionState;
    optionState.readingPanePosition = selection;
}));
//# sourceMappingURL=selectReadingPanePositionOption.js.map